<template>
  <div class="main-body">
    <div class="header">护理记录</div>
    <div class="out">

      <div class="search2">
        <el-button size="mini" plain type="primary" icon="el-icon-plus" @click="toggleModalAdd">添加</el-button>

        <div style="float:right;">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border >

        <el-table-column prop="elderlyName" label="患者" width="200" fixed></el-table-column>

        <el-table-column prop="nursingItemName" label="护理项目" width="150"></el-table-column>



        <el-table-column prop="recordType" label="护理人">
          <template slot-scope="scope">
            <p v-if="scope.row.recordType=='mediciner'">{{scope.row.medicinerName}}(医生)</p>
            <p v-if="scope.row.recordType=='nurse'">{{scope.row.nurseName}}(护士)</p>
            <p v-if="scope.row.recordType=='nurseAide'">{{scope.row.nurseAideName}}(护工)</p>
          </template>
        </el-table-column>

<!--        <el-table-column prop="status" label="护理状态">-->
<!--          <template slot-scope="scope">-->
<!--            <p v-if="scope.row.status==0">未开始</p>-->
<!--            <p v-if="scope.row.status==1">待结束</p>-->
<!--            <p v-if="scope.row.status==2">待评价</p>-->
<!--            <p v-if="scope.row.status==3">已评价</p>-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column prop="startTime" label="开始时间">
          <template slot-scope="scope">
            <p>{{scope.row.startTime | timefilters }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="结束时间">
          <template slot-scope="scope">
            <p>{{scope.row.endTime | timefilters }}</p>
          </template>
        </el-table-column>



        <!--        <el-table-column fixed="right" label="操作" width="200">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button type="text" size="medium" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
        <!--            <el-button type="text" size="medium" @click="handleEditStaff(scope.$index, scope.row)">后台账号</el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="pageSize"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
         v-on:getList="getList" v-bind:arr_ins="arr_ins" ></Add>

  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Add from "./Add";

export default {
  name: "Page",
  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },
  data(){
    return{
      tableLoading:false,

      showModalAdd:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

      type:2,

    }
  },
  components:{
    Add
  },
  created(){
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.type);
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {
      if(isSearch)this.currentPage=1

      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingRecord/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        this.tableLoading=false

        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }
      }).catch(function (error) {
        //this.tableLoading=false
        console.log(error);
      });
    },


  }
}
</script>

